import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "color-sample",
    style: _normalizeStyle({ backgroundColor: _ctx.color })
  }, null, 4 /* STYLE */))
}